import { ReactNode } from 'react'
import BrandLedShopTheLook from '../../../../shop-the-look-brand-led/components/BrandLedShopTheLook'
import { getBuilderBlockMount } from '../../../utils/getBuilderBlockMount'

export const withBrandLedItem = (items: ReactNode[]) => {
  const mount = getBuilderBlockMount('builder-brand-led-shop-the-look')
  if (!mount) return items

  const brandLedItem = (
    <li key="brand-led-shop-the-look" className="builder-gallery__item builder-gallery__item--brand-led">
      <BrandLedShopTheLook mount={mount} />
    </li>
  )

  return [brandLedItem, ...items]
}
